import { useState, useContext, useEffect } from "react";
import {
    Button, TextField, FormControl, InputLabel,
    Select, MenuItem, FormHelperText, Typography, Autocomplete
} from "@mui/material";

import { reducerContext } from "../../../../contextApi's/contextApi's";
import snackError from "../../../../helpers/snackError";
import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";
import axios from "axios";


const FaqCategory = () => {
    const { state, dispatch } = useContext(reducerContext)
    const { faqCategories } = state

    const [mode, setMode] = useState('create')
    const [category, setCategory] = useState('');
    const [description, setDescription] = useState('');
    const [parentId, setParentId] = useState('');
    const [selectedCategoryId, setSelectedCategoryId] = useState('')
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState('');
    const [subCategories, setSubCategories] = useState([])
    const [errors, setErrors] = useState({})

    const validateCategoryFields = () => {
        const newErrors = {}

        if (mode !== 'delete') {
            if (!category.trim()) {
                newErrors.category = "Category is required"
            } else if (!description.trim()) {
                newErrors.description = "Description is required"
            }
        }

        return newErrors
    }

    useEffect(() => {
        if (selectedCategoryId) {
            (async () => {
                try {

                    const result = await axios.get(`${backendHosts.ADMIN}${apiUrl.faqCategories}/${selectedCategoryId}`)
                    // const result = await httpRequest({
                    //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqCategories}/${selectedCategoryId}`,
                    //     method: "get",
                    //     instance: "instanceOne",
                    // })

                    if (result.data?.status == 200) {
                        setSubCategories(result.data?.data?.subcategories)
                    }
                } catch (error) {
                    console.log("Error while fetching subcategories list:", error)
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: error.error })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
            })()
        }
    }, [selectedCategoryId])

    const handleSubmit = async () => {
        const validationErrors = validateCategoryFields()

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }

        let url = `${backendHosts.ADMIN}${apiUrl.faqCategories}`
        let method = "post"
        let payload = {
            name: category,
            description,
            ...(parentId && { parent_id: parentId })
        }

        const targetCategoryId = selectedSubCategoryId ? selectedSubCategoryId : selectedCategoryId;

        if (mode === 'edit') {
            if (!selectedCategoryId) return
            url += `/${targetCategoryId}`
            method = "put"
        } else if (mode === "delete") {
            if (!selectedCategoryId) return
            url += `/${targetCategoryId}`
            method = "delete"
            payload = null;
        }

        try {

            const response = await axios[method](`${url}`, payload && payload )
            // const response = await httpRequest({
            //     endPoint: url,
            //     method,
            //     instance: "instanceOne",
            //     ...(payload && { requestBody: payload })
            // })

            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: response.data?.message })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })

            if (mode === "create" && response.data?.status === 201) {
                dispatch({
                    type: parentId ? 'ADD_FAQ_SUB_CATEGORY' : 'ADD_FAQ_CATEGORY',
                    payload: response.data?.category,
                })
            } else if (mode === "edit" && response.data?.status === 200) {
                setSubCategories(prev =>
                    prev.map(item =>
                        item.id === response.data?.category.id ? { ...item, ...response.data?.category } : item
                    )
                )

                dispatch({
                    type: parentId ? 'UPDATE_FAQ_SUB_CATEGORY' : 'UPDATE_FAQ_CATEGORY',
                    payload: response.data?.category,
                })
            } else if (mode === "delete" && response.data?.status === 200) {
                setSubCategories(prev =>
                    prev.filter(item => item.id !== response.data?.category.id)
                );

                dispatch({
                    type: selectedSubCategoryId ? 'DELETE_FAQ_SUB_CATEGORY' : 'DELETE_FAQ_CATEGORY',
                    payload: response.data?.category,
                })
            }

            setCategory('')
            setDescription('')
            setParentId('')
            setErrors({})
            setSelectedCategoryId('')
            setSelectedSubCategoryId('')
            setSubCategories([])

        } catch (error) {
            console.log("Error while creating category:", error)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: error.error })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }
    }

    const handleModeChange = (e) => {
        const newMode = e.target.value
        setMode(newMode)
        setCategory('')
        setDescription('')
        setParentId('');
        setSelectedCategoryId('');
        setErrors({});
    }

    const handleMainCategorySelect = async (event, newValue) => {
        setSelectedCategoryId(newValue?.id || "")
        setSelectedSubCategoryId("")
        if (newValue) {
            setCategory(newValue.name)
            setDescription(newValue.description)
            setParentId(newValue.parent_id || "")
        } else {
            setCategory("")
            setDescription("")
            setParentId("")
        }
    }


    const handleSubCategorySelect = (event, newValue) => {
        if (newValue) {
            setSelectedSubCategoryId(newValue.id)
            setCategory(newValue.name)
            setDescription(newValue.description)
            setParentId(newValue.parent_id || "")
        } else {
            setSelectedSubCategoryId("")
            setCategory("")
            setDescription("")
            setParentId("")
        }
    }

    return (
        <>
            <Typography variant="h6" fontWeight="bold">Category:</Typography>
            <FormControl fullWidth margin="normal">
                <InputLabel>Operation</InputLabel>
                <Select value={mode} label="Operation" onChange={handleModeChange}>
                    <MenuItem value="create">Create</MenuItem>
                    <MenuItem value="edit">Edit</MenuItem>
                    <MenuItem value="delete">Delete</MenuItem>
                </Select>
            </FormControl>

            {(mode === "edit" || mode === "delete") && (
                <>
                    <Autocomplete
                        options={faqCategories}
                        getOptionLabel={(option) => option.name}
                        value={faqCategories.find(cat => cat.id === selectedCategoryId) || null}
                        onChange={handleMainCategorySelect}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Category" margin="normal" fullWidth autoComplete="new-password" />
                        )} 
                    />

                    {subCategories.length > 0 && (
                        <Autocomplete
                            options={subCategories}
                            getOptionLabel={(option) => option.name}
                            value={subCategories.find(sub => sub.id === selectedSubCategoryId) || null}
                            onChange={handleSubCategorySelect}
                            renderInput={(params) => (
                                <TextField {...params} label="Select SubCategory" margin="normal" fullWidth autoComplete="new-password" />
                            )}
                        />
                    )}
                </>
            )}

            {(mode !== "delete") && (
                <>
                    
                    <TextField
                        label="Category"
                        margin="normal"
                        fullWidth
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        error={!!errors.category}
                        helperText={errors.category}
                        autoComplete="new-password"
                    />

                    <TextField
                        label="Description"
                        fullWidth
                        margin="normal"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        error={!!errors.description}
                        helperText={errors.description}
                        autoComplete="new-password"
                    />

                    <FormControl fullWidth margin="normal">
                        <InputLabel>Parent Category</InputLabel>
                        <Select
                            value={parentId}
                            label="Parent Category"
                            onChange={(e) => setParentId(e.target.value)}
                        >
                            <MenuItem value="">Select</MenuItem>
                            {faqCategories.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>
                                    {cat.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {parentId && (
                            <FormHelperText sx={{ color: '#000' }}>
                                This will create a sub-category under "{faqCategories.find(c => c.id === parentId)?.name}"
                            </FormHelperText>
                        )}
                    </FormControl>
                </>
            )}

            <Button
                onClick={handleSubmit}
                variant="contained"
                color={mode === "delete" ? "error" : "primary"}
                sx={{ mt: 2, mb: 3 }}
            >
                {mode === "create" ? "Create" : mode === "edit" ? "Update" : "Delete"} Category
            </Button>
        </>
    )
}

export default FaqCategory
